"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTab = exports.handleButtonPressWithCutomParam = exports.handleButtonPress = void 0;
/*
Space and Enter should activate the button according to wai-aria-practices
https://www.w3.org/TR/wai-aria-practices/#button
*/
var handleButtonPress = function (handleItemClick) { return function (e) {
    e.stopPropagation();
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleItemClick(e);
    }
}; };
exports.handleButtonPress = handleButtonPress;
/**
 * Handles button press with parameter
 *
 * @param handleItemClick Function to be called
 * @param args parameters array which will be passed in function handleItemClick
 * @returns
 */
var handleButtonPressWithCutomParam = function (handleItemClick, args) { return function (e) {
    e.stopPropagation();
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleItemClick(args, e);
    }
}; };
exports.handleButtonPressWithCutomParam = handleButtonPressWithCutomParam;
var selectTab = function (e) {
    var target = e.target;
    var parent = target.parentNode;
    var grandparent = parent.parentNode;
    // Remove all current selected tabs
    parent.querySelectorAll('[aria-selected="true"]').forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.classList.remove('active');
    });
    // Set this tab as selected
    target.setAttribute('aria-selected', true);
    target.classList.add('active');
    // Hide all tab panels
    grandparent.parentNode
        .querySelectorAll('[role="tabpanel"]')
        .forEach(function (p) { return p.setAttribute('hidden', 'true'); });
    // Show the selected panel
    grandparent.parentNode
        .querySelector("#".concat(target.getAttribute('aria-controls')))
        .removeAttribute('hidden');
};
exports.selectTab = selectTab;
